export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/eventFinderWorker.8c36bd1b.worker.js");
}
